export const paymentDueData = {
  data: [
    {
      landlordName: 'Landlord Name 1',
      propertyName: 'Property Name',
      amount: 100,
      status: 'ACTIVE'
    },
    {
      landlordName: 'Landlord Name 2',
      propertyName: 'Property Name',
      amount: 100,
      status: 'INACTIVE'
    },
    {
      landlordName: 'Landlord Name 3',
      propertyName: 'Property Name',
      amount: 100,
      status: 'ACTIVE'
    },
    {
      landlordName: 'Landlord Name 4',
      propertyName: 'Property Name',
      amount: 100,
      status: 'Active'
    },
    {
      landlordName: 'Landlord Name 5',
      propertyName: 'Property Name',
      amount: 100,
      status: 'ACTIVE'
    },
    {
      landlordName: 'Landlord Name 6',
      propertyName: 'Property Name',
      amount: 100,
      status: 'Active'
    },
    {
      landlordName: 'Landlord Name 7',
      propertyName: 'Property Name',
      amount: 100,
      status: 'ACTIVE'
    },
    {
      landlordName: 'Landlord Name 8',
      propertyName: 'Property Name',
      amount: 100,
      status: 'INACTIVE'
    },
    {
      landlordName: 'Landlord Name 9',
      propertyName: 'Property Name',
      amount: 100,
      status: 'INACTIVE'
    }
  ],
  titles: {
    paymentDue: 'Payment Due',
    amount: 100,
    search: 'Search',
    filter: 'Filter',
    modalTitle: 'Do you want to notify landlord?'
  },
  tableHeading: [
    'Landlord Name',
    'Property Name',
    'Amount',
    'Pay Rent',
    'Details'
  ]
};
